if (!customElements.get('cart-items')) {
  
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.cart_items = this.dataset.cartItems;
      this.section_id = this.dataset.sectionId;
    }

    connectedCallback() {
      const section = document.querySelector(`[data-cart-items-${this.section_id}`);
      const parsed_items = JSON.parse(this.cart_items);

      document.addEventListener('cart-updated', (event) => {
        const items = event.detail.cart.items;

        if (!items.length) {
          section.classList.remove('block');
          section.classList.add('hidden');
        } else {
          section.classList.remove('hidden');
          section.classList.add('block');
          this.buildInnerHtml(items);
        }
      });

      if (!parsed_items.length) return;

      section.classList.remove('hidden');
      section.classList.add('block');
      this.buildInnerHtml(parsed_items);
    }

    buildInnerHtml(items) {
      this.innerHTML = `
        <div class="relative z-[1]">
          <swiper-carousel 
            data-recommended-product-row 
            data-space-between="8"
            data-slides-per-view="4"
            data-slides-per-view-mobile="2.5"
            class="flex flex-col w-full pb-8"
            data-rewind="true"
            data-pagination="true"
            data-centered="true"
          >
            <button data-button-prev class="button-slider disabled:hidden hidden md:block absolute left-0 top-1/2 z-10 bg-secondaryLight border-primaryLight transform -translate-x-1/2 shadow-lg" data-prev>
              <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
              </svg>
            </button>
            <button data-button-next class="button-slider disabled:hidden hidden md:block absolute right-0 top-1/2 z-10 bg-secondaryLight border-primaryLight shadow-lg transform translate-x-1/2" data-next>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
              </svg>
            </button>
            <div class="swiper-wrapper">
              ${items.map((item) => `
                <div class="swiper-slide [&_product-tile]:h-full !h-auto">
                  <intersection-loader 
                    data-url="/products/${item.handle}" 
                    data-section-id="product-tile"
                  ></intersection-loader>                    
                </div>
              `).join('')}
            </div>
          </swiper-carousel>
        </div>
      `;

      const waitForSwiper = ((selector, callback) => {
				const observer = new MutationObserver((mutationsList) => {
					for (const mutation of mutationsList) {
						if (mutation.type === 'childList') {
							const swiper_el = document.querySelector(selector);
							if (swiper_el) {
								callback(swiper_el);
								observer.disconnect();
							}
						}
					}
				});

				observer.observe(document.body, { childList: true, subtree: true });
			});

			waitForSwiper('[data-recommended-product-row]', (swiper_el) => {
        const prev_button = this.querySelector('[data-button-prev]');
        const next_button = this.querySelector('[data-button-next]');

        if (swiper_el.swiper.slides.length < 5) {
          prev_button.classList.add('!hidden');
          next_button.classList.add('!hidden');
        } else {
          prev_button.classList.remove('!hidden');
          next_button.classList.remove('!hidden');
        }
			});
    }
  }

  customElements.define('cart-items', CartItems);
}